import React from 'react';
import { vehicleOptionsDictionary } from '../../../dictionaries';
import { renderRecordValue } from '../../../utils';
import styles from './index.module.css';
import UberHealthIcon from '../../../assets/svgs/uberHealth.svg';

export const renderVehicleTypeWithUberBadge = (vehicleType) => {
  const isUber = vehicleType === 'uberAmbulatoryRide';
  const vehicleLabel = vehicleOptionsDictionary?.[vehicleType] || renderRecordValue(vehicleType);
  
  if (isUber) {
    return (
      <div className={styles.vehicleTypeWrapper}>
        <span>{vehicleLabel}</span>
        <span className={styles.uberHealthTag}>
          <img src={UberHealthIcon} alt="Uber Health" className={styles.uberHealthIcon} />
          Uber Health
        </span>
      </div>
    );
  }
  
  return <span>{vehicleLabel}</span>;
};
